import { useState } from "react";
import { TextField } from "@mui/material";
import { FormDialog } from "../popup";

const EditMaterialModal = ({ onClose, onSubmit, materialData }) => {
  const [formData, setFormData] = useState({ name: materialData?.name || "", category: materialData?.category || "", rate: materialData?.rate || "" });
  const change = (name) => (event) => setFormData((current) => ({ ...current, [name]: event.target.value }));
  return <FormDialog open onClose={onClose} title="Edit material" subtitle="Update inventory material details" onSubmit={(event) => { event.preventDefault(); onSubmit(materialData._id, formData); }} submitLabel="Update">
    <TextField required label="Name" value={formData.name} onChange={change("name")} fullWidth autoFocus />
    <TextField label="Category" value={formData.category} onChange={change("category")} fullWidth />
    <TextField label="Rate" type="number" value={formData.rate} onChange={change("rate")} fullWidth />
  </FormDialog>;
};

export default EditMaterialModal;
